module.exports = __webpack_public_path__ + "big3Product_og.2pJd7.jpg";